import { createContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const ShopContext = createContext();

const ShopContextProvider = ({ children }) => {

  const currency = "$";
  const delivery_fee = 10;
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [search, setSearch] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [cartItems, setCartItems] = useState({});
  const [products, setProducts] = useState([]);
  const [token, setToken] = useState(localStorage.getItem("token") || "");

  const navigate = useNavigate();
  const sizedProducts = ["jersey", "hoodie", "shirt"];

  /* =====================================================
     🔍 DEBUG: CART STATE WATCHER
  ===================================================== */
  useEffect(() => {
  
  }, [cartItems]);

  /* =====================================================
     FETCH PRODUCTS
  ===================================================== */
  const getProductsData = async () => {
 
    try {
      const res = await axios.get(backendUrl + "/api/product/list");
      if (res.data.success) {
        setProducts(res.data.products);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load products");
    }
  };

  /* =====================================================
     🔍 FETCH USER CART (DEBUGGED)
  ===================================================== */
  const getUserCart = async () => {
    if (!token) {
     
      return;
    }

   

    try {
      const res = await axios.get(
        backendUrl + "/api/cart/get",
        { headers: { token } }
      );

 

      if (res.data.success) {
        setCartItems(res.data.cartData || {});
      }
    } catch (error) {
  
      toast.error("Failed to load cart");
    }
  };

  /* =====================================================
     ADD TO CART (DEBUGGED)
  ===================================================== */
const addToCart = async (itemId, size) => {


  const product = products.find(p => p._id === itemId);
  if (!product) return;

  const needsSize = sizedProducts.includes(product.category);
  const finalSize = needsSize ? size : "default";

  if (!token) {
    toast.error("Please login first");
    return;
  }

  try {
    const res = await axios.post(
      backendUrl + "/api/cart/add",
      { itemId, size: finalSize },
      { headers: { token } }
    );

    if (res.data.success) {
      await getUserCart();
    }
  } catch (error) {
    
    toast.error("Failed to add to cart");
  }
};

  /* =====================================================
     🔍 UPDATE QUANTITY (CRITICAL DEBUG)
  ===================================================== */
const updateQuantity = async (itemId, size, quantity) => {
  const product = products.find(p => p._id === itemId);
  if (!product) return;

  const needsSize = sizedProducts.includes(product.category);
  const finalSize = needsSize ? size : "default";

  if (!token) return;

  try {
    const res = await axios.post(
      backendUrl + "/api/cart/update",
      { itemId, size: finalSize, quantity },
      { headers: { token } }
    );

   
    if (res.data.success) {
      setCartItems(res.data.cartData);
    }
  } catch (error) {
    console.error(error);
    toast.error("Failed to update cart");
  }
};



  /* =====================================================
     CART HELPERS
  ===================================================== */
  const getCartCount = () => {
    let total = 0;
    for (const itemId in cartItems) {
      for (const size in cartItems[itemId]) {
        total += cartItems[itemId][size];
      }
    }
    return total;
  };

  const getCartAmount = () => {
    let total = 0;
    for (const itemId in cartItems) {
      const product = products.find(p => p._id === itemId);
      if (!product) continue;
      for (const size in cartItems[itemId]) {
        total += product.price * cartItems[itemId][size];
      }
    }
    return total;
  };

  /* =====================================================
     🔍 INITIAL LOAD EFFECT
  ===================================================== */
useEffect(() => {
  const init = async () => {
    await getProductsData();
    if (token) {
      await getUserCart();
    }
  };
  init();
}, [token]); 


  /* =====================================================
     🔍 TOKEN EFFECT
  ===================================================== */
  useEffect(() => {
   
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
      setCartItems({});
    }
  }, [token]);

  const value = {
    products,
    currency,
    delivery_fee,
    search,
    setSearch,
    showSearch,
    setShowSearch,
    cartItems,
    addToCart,
    updateQuantity,
    getCartCount,
    getCartAmount,
    navigate,
    backendUrl,
    token,
    setToken,
    setCartItems
  };

  return (
    <ShopContext.Provider value={value}>
      {children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;
